<template>
    <div class="d-flex flex-wrap">
        <menu-item v-for="(option, i) in options" :key="option.name" :label="option.name" :tooltip-key="option.tooltip_key">
            <select class="form-control" :value="option.selected" :data-index="i" @change="handleChange">
                <option value="false">{{ $t('general.no') }}</option>
                <option value="true">{{ $t('general.yes') }}</option>
            </select>
        </menu-item>
    </div>
</template>

<script>
    import MenuItem from './MenuItem';
    import {mapGetters, mapMutations} from "vuex";

  export default {
    name: "MenuFrame",

    components: {
      MenuItem
    },

    computed: {
      ...mapGetters({
        options: 'frameOptions/getAll'
      })
    },

    methods: {
      ...mapMutations({
        store: 'frameOptions/setSelected'
      }),

      handleChange(e) {
        const bool = e.target.value === 'true'; //make sure always a bool
        const index = parseInt(e.target.dataset.index);

        this.store({index, bool});
      }
    }
  }
</script>
